const StudentData = [
    {
        id: 1,
        name: 'Evelyn',
        assignment: 'SCRUM',
        difficult: 3,
        fun: 4
    },
    {
        id: 2,
        name: 'Evelyn',
        assignment: 'W1D1-1',
        difficult: 3,
        fun: 3
    },
    {
        id: 3,
        name: 'Evelyn',
        assignment: 'W1D2-1',
        difficult: 1,
        fun: 3
    },
    {
        id: 4,
        name: 'Evelyn',
        assignment: 'W1D2-2',
        difficult: 1,
        fun: 4
    },
    {
        id: 5,
        name: 'Evelyn',
        assignment: 'W1D2-3',
        difficult: 2,
        fun: 3
    },
    {
        id: 6,
        name: 'Evelyn',
        assignment: 'W1D2-4',
        difficult: 3,
        fun: 4
    },
    {
        id: 7,
        name: 'Evelyn',
        assignment: 'W1D2-5',
        difficult: 3,
        fun: 4
    },
    {
        id: 8,
        name: 'Evelyn',
        assignment: 'W1D3-1',
        difficult: 3,
        fun: 4
    },
    {
        id: 9,
        name: 'Evelyn',
        assignment: 'W1D3-2',
        difficult: 3,
        fun: 4
    },
    {
        id: 10,
        name: 'Evelyn',
        assignment: 'W1D3-4',
        difficult: 4,
        fun: 4
    },
    {
        id: 11,
        name: 'Evelyn',
        assignment: 'W1D3-5',
        difficult: 4,
        fun: 4
    },
    {
        id: 12,
        name: 'Evelyn',
        assignment: 'W1D3 - Project - Guess-the-number',
        difficult: 5,
        fun: 5
    },
    {
        id: 13,
        name: 'Evelyn',
        assignment: 'W1D4-1',
        difficult: 4,
        fun: 5
    },
    {
        id: 14,
        name: 'Evelyn',
        assignment: 'W1D4 - Project - Kleurentoggle',
        difficult: 3,
        fun: 4
    },
    {
        id: 15,
        name: 'Evelyn',
        assignment: 'W1D5 - Project - Galgje',
        difficult: 3,
        fun: 3
    },
    {
        id: 16,
        name: 'Evelyn',
        assignment: 'W2D1-1',
        difficult: 1,
        fun: 5
    },
    {
        id: 17,
        name: 'Evelyn',
        assignment: 'W2D1-2',
        difficult: 2,
        fun: 5
    },
    {
        id: 18,
        name: 'Evelyn',
        assignment: 'W2D2-1',
        difficult: 3,
        fun: 4
    },
    {
        id: 19,
        name: 'Evelyn',
        assignment: 'W2D2-2',
        difficult: 3,
        fun: 4
    },
    {
        id: 20,
        name: 'Evelyn',
        assignment: 'W2D2-3',
        difficult: 3,
        fun: 4
    },
    {
        id: 21,
        name: 'Evelyn',
        assignment: 'W2D3-1',
        difficult: 4,
        fun: 4
    },
    {
        id: 22,
        name: 'Evelyn',
        assignment: 'W2D3-2',
        difficult: 1,
        fun: 3
    },
    {
        id: 23,
        name: 'Evelyn',
        assignment: 'W2D3-3',
        difficult: 4,
        fun: 4
    },
    {
        id: 24,
        name: 'Evelyn',
        assignment: 'W2D4-1',
        difficult: 1,
        fun: 3
    },
    {
        id: 25,
        name: 'Evelyn',
        assignment: 'W2D4-2',
        difficult: 4,
        fun: 4
    },
    {
        id: 26,
        name: 'Evelyn',
        assignment: 'W2D4-3',
        difficult: 1,
        fun: 3
    },
    {
        id: 27,
        name: 'Evelyn',
        assignment: 'W2D5 - Project - Filmzoeker',
        difficult: 3,
        fun: 4
    },
    {
        id: 28,
        name: 'Evelyn',
        assignment: 'W3D1-1',
        difficult: 3,
        fun: 4
    },
    {
        id: 29,
        name: 'Evelyn',
        assignment: 'W3D1-2',
        difficult: 2,
        fun: 4
    },
    {
        id: 30,
        name: 'Evelyn',
        assignment: 'W3D1-3',
        difficult: 3,
        fun: 4
    },
    {
        id: 31,
        name: 'Evelyn',
        assignment: 'W3D1-4',
        difficult: 3,
        fun: 3
    },
    {
        id: 32,
        name: 'Evelyn',
        assignment: 'W3D2-1',
        difficult: 2,
        fun: 4
    },
    {
        id: 33,
        name: 'Evelyn',
        assignment: 'W3D2-2',
        difficult: 3,
        fun: 3
    },
    {
        id: 34,
        name: 'Evelyn',
        assignment: 'W3D2-3',
        difficult: 3,
        fun: 5
    },
    {
        id: 35,
        name: 'Evelyn',
        assignment: 'W3D3-1',
        difficult: 4,
        fun: 4
    },
    {
        id: 36,
        name: 'Evelyn',
        assignment: 'W3D3-2',
        difficult: 4,
        fun: 5
    },
    {
        id: 37,
        name: 'Evelyn',
        assignment: 'W3D3-3',
        difficult: 3,
        fun: 5
    },
    {
        id: 38,
        name: 'Evelyn',
        assignment: 'W3D3-4',
        difficult: 4,
        fun: 5
    },
    {
        id: 39,
        name: 'Evelyn',
        assignment: 'W3D4-1',
        difficult: 5,
        fun: 5
    },
    {
        id: 40,
        name: 'Evelyn',
        assignment: 'W3D4-2',
        difficult: 1,
        fun: 5
    },
    {
        id: 41,
        name: 'Evelyn',
        assignment: 'W3D5 - Project - Todo-List',
        difficult: 2,
        fun: 5
    },
    {
        id: 42,
        name: 'Evelyn',
        assignment: 'W4D2-1',
        difficult: 1,
        fun: 5
    },
    {
        id: 43,
        name: 'Evelyn',
        assignment: 'W4D2-2',
        difficult: 1,
        fun: 5
    },
    {
        id: 44,
        name: 'Evelyn',
        assignment: 'W4D2-3',
        difficult: 1,
        fun: 5
    },
    {
        id: 45,
        name: 'Evelyn',
        assignment: 'W4D2-4',
        difficult: 1,
        fun: 5
    },
    {
        id: 46,
        name: 'Evelyn',
        assignment: 'W4D3-1',
        difficult: 1,
        fun: 5
    },
    {
        id: 47,
        name: 'Evelyn',
        assignment: 'W4D3-2',
        difficult: 1,
        fun: 5
    },
    {
        id: 48,
        name: 'Evelyn',
        assignment: 'W4D3-3',
        difficult: 1,
        fun: 5
    },
    {
        id: 49,
        name: 'Evelyn',
        assignment: 'W4D3-4',
        difficult: 1,
        fun: 5
    },
    {
        id: 50,
        name: 'Evelyn',
        assignment: 'W4D3-5',
        difficult: 1,
        fun: 5
    },
    {
        id: 51,
        name: 'Evelyn',
        assignment: 'W4D3 - Project - Next-Level CSS',
        difficult: 1,
        fun: 5
    },
    {
        id: 52,
        name: 'Evelyn',
        assignment: 'W5D4-1',
        difficult: 3,
        fun: 4
    },
    {
        id: 53,
        name: 'Evelyn',
        assignment: 'W5D5 - Project - Lil_Playlist',
        difficult: 4,
        fun: 3
    },
    {
        id: 54,
        name: 'Evelyn',
        assignment: 'W6D1-1',
        difficult: 5,
        fun: 5
    },
    {
        id: 55,
        name: 'Evelyn',
        assignment: 'W6D2-1',
        difficult: 4,
        fun: 3
    },
    {
        id: 56,
        name: 'Evelyn',
        assignment: 'W6D2 - Project - Eindopdracht',
        difficult: 5,
        fun: 5
    },
    {
        id: 57,
        name: 'Aranka',
        assignment: 'SCRUM',
        difficult: 1,
        fun: 1
    },
    {
        id: 58,
        name: 'Aranka',
        assignment: 'W1D1-1',
        difficult: 4,
        fun: 3
    },
    {
        id: 59,
        name: 'Aranka',
        assignment: 'W1D2-1',
        difficult: 3,
        fun: 1
    },
    {
        id: 60,
        name: 'Aranka',
        assignment: 'W1D2-2',
        difficult: 3,
        fun: 2
    },
    {
        id: 61,
        name: 'Aranka',
        assignment: 'W1D2-3',
        difficult: 4,
        fun: 1
    },
    {
        id: 62,
        name: 'Aranka',
        assignment: 'W1D2-4',
        difficult: 2,
        fun: 3
    },
    {
        id: 63,
        name: 'Aranka',
        assignment: 'W1D2-5',
        difficult: 4,
        fun: 2
    },
    {
        id: 64,
        name: 'Aranka',
        assignment: 'W1D3-1',
        difficult: 3,
        fun: 2
    },
    {
        id: 65,
        name: 'Aranka',
        assignment: 'W1D3-2',
        difficult: 2,
        fun: 1
    },
    {
        id: 66,
        name: 'Aranka',
        assignment: 'W1D3-4',
        difficult: 1,
        fun: 2
    },
    {
        id: 67,
        name: 'Aranka',
        assignment: 'W1D3-5',
        difficult: 4,
        fun: 1
    },
    {
        id: 68,
        name: 'Aranka',
        assignment: 'W1D3 - Project - Guess-the-number',
        difficult: 2,
        fun: 3
    },
    {
        id: 69,
        name: 'Aranka',
        assignment: 'W1D4-1',
        difficult: 3,
        fun: 2
    },
    {
        id: 70,
        name: 'Aranka',
        assignment: 'W1D4 - Project - Kleurentoggle',
        difficult: 4,
        fun: 3
    },
    {
        id: 71,
        name: 'Aranka',
        assignment: 'W1D5 - Project - Galgje',
        difficult: 4,
        fun: 1
    },
    {
        id: 72,
        name: 'Aranka',
        assignment: 'W2D1-1',
        difficult: 2,
        fun: 4
    },
    {
        id: 73,
        name: 'Aranka',
        assignment: 'W2D1-2',
        difficult: 4,
        fun: 4
    },
    {
        id: 74,
        name: 'Aranka',
        assignment: 'W2D2-1',
        difficult: 3,
        fun: 4
    },
    {
        id: 75,
        name: 'Aranka',
        assignment: 'W2D2-2',
        difficult: 3,
        fun: 4
    },
    {
        id: 76,
        name: 'Aranka',
        assignment: 'W2D2-3',
        difficult: 1,
        fun: 4
    },
    {
        id: 77,
        name: 'Aranka',
        assignment: 'W2D3-1',
        difficult: 4,
        fun: 3
    },
    {
        id: 78,
        name: 'Aranka',
        assignment: 'W2D3-2',
        difficult: 4,
        fun: 1
    },
    {
        id: 79,
        name: 'Aranka',
        assignment: 'W2D3-3',
        difficult: 1,
        fun: 1
    },
    {
        id: 80,
        name: 'Aranka',
        assignment: 'W2D4-1',
        difficult: 1,
        fun: 4
    },
    {
        id: 81,
        name: 'Aranka',
        assignment: 'W2D4-2',
        difficult: 2,
        fun: 3
    },
    {
        id: 82,
        name: 'Aranka',
        assignment: 'W2D4-3',
        difficult: 2,
        fun: 3
    },
    {
        id: 83,
        name: 'Aranka',
        assignment: 'W2D5 - Project - Filmzoeker',
        difficult: 2,
        fun: 2
    },
    {
        id: 84,
        name: 'Aranka',
        assignment: 'W3D1-1',
        difficult: 4,
        fun: 2
    },
    {
        id: 85,
        name: 'Aranka',
        assignment: 'W3D1-2',
        difficult: 3,
        fun: 2
    },
    {
        id: 86,
        name: 'Aranka',
        assignment: 'W3D1-3',
        difficult: 1,
        fun: 4
    },
    {
        id: 87,
        name: 'Aranka',
        assignment: 'W3D1-4',
        difficult: 1,
        fun: 3
    },
    {
        id: 88,
        name: 'Aranka',
        assignment: 'W3D2-1',
        difficult: 1,
        fun: 3
    },
    {
        id: 89,
        name: 'Aranka',
        assignment: 'W3D2-2',
        difficult: 2,
        fun: 3
    },
    {
        id: 90,
        name: 'Aranka',
        assignment: 'W3D2-3',
        difficult: 2,
        fun: 3
    },
    {
        id: 91,
        name: 'Aranka',
        assignment: 'W3D3-1',
        difficult: 2,
        fun: 2
    },
    {
        id: 92,
        name: 'Aranka',
        assignment: 'W3D3-2',
        difficult: 4,
        fun: 3
    },
    {
        id: 93,
        name: 'Aranka',
        assignment: 'W3D3-3',
        difficult: 3,
        fun: 3
    },
    {
        id: 94,
        name: 'Aranka',
        assignment: 'W3D3-4',
        difficult: 1,
        fun: 3
    },
    {
        id: 95,
        name: 'Aranka',
        assignment: 'W3D4-1',
        difficult: 1,
        fun: 1
    },
    {
        id: 96,
        name: 'Aranka',
        assignment: 'W3D4-2',
        difficult: 3,
        fun: 2
    },
    {
        id: 97,
        name: 'Aranka',
        assignment: 'W3D5 - Project - Todo-List',
        difficult: 1,
        fun: 1
    },
    {
        id: 98,
        name: 'Aranka',
        assignment: 'W4D2-1',
        difficult: 2,
        fun: 1
    },
    {
        id: 99,
        name: 'Aranka',
        assignment: 'W4D2-2',
        difficult: 3,
        fun: 2
    },
    {
        id: 100,
        name: 'Aranka',
        assignment: 'W4D2-3',
        difficult: 2,
        fun: 2
    },
    {
        id: 101,
        name: 'Aranka',
        assignment: 'W4D2-4',
        difficult: 3,
        fun: 4
    },
    {
        id: 102,
        name: 'Aranka',
        assignment: 'W4D3-1',
        difficult: 2,
        fun: 1
    },
    {
        id: 103,
        name: 'Aranka',
        assignment: 'W4D3-2',
        difficult: 4,
        fun: 4
    },
    {
        id: 104,
        name: 'Aranka',
        assignment: 'W4D3-3',
        difficult: 3,
        fun: 1
    },
    {
        id: 105,
        name: 'Aranka',
        assignment: 'W4D3-4',
        difficult: 3,
        fun: 1
    },
    {
        id: 106,
        name: 'Aranka',
        assignment: 'W4D3-5',
        difficult: 4,
        fun: 3
    },
    {
        id: 107,
        name: 'Aranka',
        assignment: 'W4D3 - Project - Next-Level CSS',
        difficult: 4,
        fun: 4
    },
    {
        id: 108,
        name: 'Aranka',
        assignment: 'W5D4-1',
        difficult: 1,
        fun: 3
    },
    {
        id: 109,
        name: 'Aranka',
        assignment: 'W5D5 - Project - Lil_Playlist',
        difficult: 3,
        fun: 2
    },
    {
        id: 110,
        name: 'Aranka',
        assignment: 'W6D1-1',
        difficult: 1,
        fun: 1
    },
    {
        id: 111,
        name: 'Aranka',
        assignment: 'W6D2-1',
        difficult: 2,
        fun: 2
    },
    {
        id: 112,
        name: 'Aranka',
        assignment: 'W6D2 - Project - Eindopdracht',
        difficult: 3,
        fun: 4
    },
    {
        id: 113,
        name: 'Floris',
        assignment: 'SCRUM',
        difficult: 2,
        fun: 1
    },
    {
        id: 114,
        name: 'Floris',
        assignment: 'W1D1-1',
        difficult: 4,
        fun: 3
    },
    {
        id: 115,
        name: 'Floris',
        assignment: 'W1D2-1',
        difficult: 1,
        fun: 2
    },
    {
        id: 116,
        name: 'Floris',
        assignment: 'W1D2-2',
        difficult: 1,
        fun: 4
    },
    {
        id: 117,
        name: 'Floris',
        assignment: 'W1D2-3',
        difficult: 1,
        fun: 4
    },
    {
        id: 118,
        name: 'Floris',
        assignment: 'W1D2-4',
        difficult: 3,
        fun: 4
    },
    {
        id: 119,
        name: 'Floris',
        assignment: 'W1D2-5',
        difficult: 1,
        fun: 3
    },
    {
        id: 120,
        name: 'Floris',
        assignment: 'W1D3-1',
        difficult: 2,
        fun: 4
    },
    {
        id: 121,
        name: 'Floris',
        assignment: 'W1D3-2',
        difficult: 4,
        fun: 4
    },
    {
        id: 122,
        name: 'Floris',
        assignment: 'W1D3-4',
        difficult: 4,
        fun: 2
    },
    {
        id: 123,
        name: 'Floris',
        assignment: 'W1D3-5',
        difficult: 2,
        fun: 4
    },
    {
        id: 124,
        name: 'Floris',
        assignment: 'W1D3 - Project - Guess-the-number',
        difficult: 2,
        fun: 2
    },
    {
        id: 125,
        name: 'Floris',
        assignment: 'W1D4-1',
        difficult: 1,
        fun: 3
    },
    {
        id: 126,
        name: 'Floris',
        assignment: 'W1D4 - Project - Kleurentoggle',
        difficult: 4,
        fun: 3
    },
    {
        id: 127,
        name: 'Floris',
        assignment: 'W1D5 - Project - Galgje',
        difficult: 4,
        fun: 4
    },
    {
        id: 128,
        name: 'Floris',
        assignment: 'W2D1-1',
        difficult: 2,
        fun: 2
    },
    {
        id: 129,
        name: 'Floris',
        assignment: 'W2D1-2',
        difficult: 4,
        fun: 1
    },
    {
        id: 130,
        name: 'Floris',
        assignment: 'W2D2-1',
        difficult: 4,
        fun: 1
    },
    {
        id: 131,
        name: 'Floris',
        assignment: 'W2D2-2',
        difficult: 2,
        fun: 2
    },
    {
        id: 132,
        name: 'Floris',
        assignment: 'W2D2-3',
        difficult: 4,
        fun: 2
    },
    {
        id: 133,
        name: 'Floris',
        assignment: 'W2D3-1',
        difficult: 1,
        fun: 1
    },
    {
        id: 134,
        name: 'Floris',
        assignment: 'W2D3-2',
        difficult: 1,
        fun: 2
    },
    {
        id: 135,
        name: 'Floris',
        assignment: 'W2D3-3',
        difficult: 3,
        fun: 3
    },
    {
        id: 136,
        name: 'Floris',
        assignment: 'W2D4-1',
        difficult: 4,
        fun: 4
    },
    {
        id: 137,
        name: 'Floris',
        assignment: 'W2D4-2',
        difficult: 3,
        fun: 1
    },
    {
        id: 138,
        name: 'Floris',
        assignment: 'W2D4-3',
        difficult: 4,
        fun: 1
    },
    {
        id: 139,
        name: 'Floris',
        assignment: 'W2D5 - Project - Filmzoeker',
        difficult: 4,
        fun: 1
    },
    {
        id: 140,
        name: 'Floris',
        assignment: 'W3D1-1',
        difficult: 4,
        fun: 3
    },
    {
        id: 141,
        name: 'Floris',
        assignment: 'W3D1-2',
        difficult: 2,
        fun: 3
    },
    {
        id: 142,
        name: 'Floris',
        assignment: 'W3D1-3',
        difficult: 2,
        fun: 3
    },
    {
        id: 143,
        name: 'Floris',
        assignment: 'W3D1-4',
        difficult: 3,
        fun: 3
    },
    {
        id: 144,
        name: 'Floris',
        assignment: 'W3D2-1',
        difficult: 3,
        fun: 2
    },
    {
        id: 145,
        name: 'Floris',
        assignment: 'W3D2-2',
        difficult: 2,
        fun: 2
    },
    {
        id: 146,
        name: 'Floris',
        assignment: 'W3D2-3',
        difficult: 3,
        fun: 2
    },
    {
        id: 147,
        name: 'Floris',
        assignment: 'W3D3-1',
        difficult: 4,
        fun: 4
    },
    {
        id: 148,
        name: 'Floris',
        assignment: 'W3D3-2',
        difficult: 2,
        fun: 4
    },
    {
        id: 149,
        name: 'Floris',
        assignment: 'W3D3-3',
        difficult: 2,
        fun: 1
    },
    {
        id: 150,
        name: 'Floris',
        assignment: 'W3D3-4',
        difficult: 3,
        fun: 2
    },
    {
        id: 151,
        name: 'Floris',
        assignment: 'W3D4-1',
        difficult: 1,
        fun: 3
    },
    {
        id: 152,
        name: 'Floris',
        assignment: 'W3D4-2',
        difficult: 2,
        fun: 2
    },
    {
        id: 153,
        name: 'Floris',
        assignment: 'W3D5 - Project - Todo-List',
        difficult: 4,
        fun: 2
    },
    {
        id: 154,
        name: 'Floris',
        assignment: 'W4D2-1',
        difficult: 1,
        fun: 4
    },
    {
        id: 155,
        name: 'Floris',
        assignment: 'W4D2-2',
        difficult: 2,
        fun: 3
    },
    {
        id: 156,
        name: 'Floris',
        assignment: 'W4D2-3',
        difficult: 2,
        fun: 4
    },
    {
        id: 157,
        name: 'Floris',
        assignment: 'W4D2-4',
        difficult: 1,
        fun: 2
    },
    {
        id: 158,
        name: 'Floris',
        assignment: 'W4D3-1',
        difficult: 1,
        fun: 4
    },
    {
        id: 159,
        name: 'Floris',
        assignment: 'W4D3-2',
        difficult: 4,
        fun: 4
    },
    {
        id: 160,
        name: 'Floris',
        assignment: 'W4D3-3',
        difficult: 3,
        fun: 2
    },
    {
        id: 161,
        name: 'Floris',
        assignment: 'W4D3-4',
        difficult: 2,
        fun: 2
    },
    {
        id: 162,
        name: 'Floris',
        assignment: 'W4D3-5',
        difficult: 4,
        fun: 1
    },
    {
        id: 163,
        name: 'Floris',
        assignment: 'W4D3 - Project - Next-Level CSS',
        difficult: 2,
        fun: 2
    },
    {
        id: 164,
        name: 'Floris',
        assignment: 'W5D4-1',
        difficult: 1,
        fun: 3
    },
    {
        id: 165,
        name: 'Floris',
        assignment: 'W5D5 - Project - Lil_Playlist',
        difficult: 3,
        fun: 1
    },
    {
        id: 166,
        name: 'Floris',
        assignment: 'W6D1-1',
        difficult: 3,
        fun: 2
    },
    {
        id: 167,
        name: 'Floris',
        assignment: 'W6D2-1',
        difficult: 1,
        fun: 1
    },
    {
        id: 168,
        name: 'Floris',
        assignment: 'W6D2 - Project - Eindopdracht',
        difficult: 4,
        fun: 1
    },
    {
        id: 169,
        name: 'Hector',
        assignment: 'SCRUM',
        difficult: 1,
        fun: 2
    },
    {
        id: 170,
        name: 'Hector',
        assignment: 'W1D1-1',
        difficult: 1,
        fun: 4
    },
    {
        id: 171,
        name: 'Hector',
        assignment: 'W1D2-1',
        difficult: 2,
        fun: 4
    },
    {
        id: 172,
        name: 'Hector',
        assignment: 'W1D2-2',
        difficult: 2,
        fun: 3
    },
    {
        id: 173,
        name: 'Hector',
        assignment: 'W1D2-3',
        difficult: 1,
        fun: 2
    },
    {
        id: 174,
        name: 'Hector',
        assignment: 'W1D2-4',
        difficult: 1,
        fun: 3
    },
    {
        id: 175,
        name: 'Hector',
        assignment: 'W1D2-5',
        difficult: 3,
        fun: 1
    },
    {
        id: 176,
        name: 'Hector',
        assignment: 'W1D3-1',
        difficult: 1,
        fun: 4
    },
    {
        id: 177,
        name: 'Hector',
        assignment: 'W1D3-2',
        difficult: 4,
        fun: 3
    },
    {
        id: 178,
        name: 'Hector',
        assignment: 'W1D3-4',
        difficult: 3,
        fun: 1
    },
    {
        id: 179,
        name: 'Hector',
        assignment: 'W1D3-5',
        difficult: 4,
        fun: 2
    },
    {
        id: 180,
        name: 'Hector',
        assignment: 'W1D3 - Project - Guess-the-number',
        difficult: 3,
        fun: 1
    },
    {
        id: 181,
        name: 'Hector',
        assignment: 'W1D4-1',
        difficult: 1,
        fun: 1
    },
    {
        id: 182,
        name: 'Hector',
        assignment: 'W1D4 - Project - Kleurentoggle',
        difficult: 1,
        fun: 3
    },
    {
        id: 183,
        name: 'Hector',
        assignment: 'W1D5 - Project - Galgje',
        difficult: 2,
        fun: 4
    },
    {
        id: 184,
        name: 'Hector',
        assignment: 'W2D1-1',
        difficult: 4,
        fun: 4
    },
    {
        id: 185,
        name: 'Hector',
        assignment: 'W2D1-2',
        difficult: 3,
        fun: 2
    },
    {
        id: 186,
        name: 'Hector',
        assignment: 'W2D2-1',
        difficult: 4,
        fun: 3
    },
    {
        id: 187,
        name: 'Hector',
        assignment: 'W2D2-2',
        difficult: 1,
        fun: 2
    },
    {
        id: 188,
        name: 'Hector',
        assignment: 'W2D2-3',
        difficult: 3,
        fun: 2
    },
    {
        id: 189,
        name: 'Hector',
        assignment: 'W2D3-1',
        difficult: 3,
        fun: 1
    },
    {
        id: 190,
        name: 'Hector',
        assignment: 'W2D3-2',
        difficult: 4,
        fun: 2
    },
    {
        id: 191,
        name: 'Hector',
        assignment: 'W2D3-3',
        difficult: 4,
        fun: 2
    },
    {
        id: 192,
        name: 'Hector',
        assignment: 'W2D4-1',
        difficult: 2,
        fun: 4
    },
    {
        id: 193,
        name: 'Hector',
        assignment: 'W2D4-2',
        difficult: 4,
        fun: 1
    },
    {
        id: 194,
        name: 'Hector',
        assignment: 'W2D4-3',
        difficult: 3,
        fun: 2
    },
    {
        id: 195,
        name: 'Hector',
        assignment: 'W2D5 - Project - Filmzoeker',
        difficult: 4,
        fun: 1
    },
    {
        id: 196,
        name: 'Hector',
        assignment: 'W3D1-1',
        difficult: 1,
        fun: 1
    },
    {
        id: 197,
        name: 'Hector',
        assignment: 'W3D1-2',
        difficult: 1,
        fun: 4
    },
    {
        id: 198,
        name: 'Hector',
        assignment: 'W3D1-3',
        difficult: 3,
        fun: 2
    },
    {
        id: 199,
        name: 'Hector',
        assignment: 'W3D1-4',
        difficult: 4,
        fun: 3
    },
    {
        id: 200,
        name: 'Hector',
        assignment: 'W3D2-1',
        difficult: 1,
        fun: 3
    },
    {
        id: 201,
        name: 'Hector',
        assignment: 'W3D2-2',
        difficult: 4,
        fun: 3
    },
    {
        id: 202,
        name: 'Hector',
        assignment: 'W3D2-3',
        difficult: 2,
        fun: 1
    },
    {
        id: 203,
        name: 'Hector',
        assignment: 'W3D3-1',
        difficult: 4,
        fun: 4
    },
    {
        id: 204,
        name: 'Hector',
        assignment: 'W3D3-2',
        difficult: 3,
        fun: 1
    },
    {
        id: 205,
        name: 'Hector',
        assignment: 'W3D3-3',
        difficult: 2,
        fun: 4
    },
    {
        id: 206,
        name: 'Hector',
        assignment: 'W3D3-4',
        difficult: 4,
        fun: 1
    },
    {
        id: 207,
        name: 'Hector',
        assignment: 'W3D4-1',
        difficult: 3,
        fun: 4
    },
    {
        id: 208,
        name: 'Hector',
        assignment: 'W3D4-2',
        difficult: 1,
        fun: 4
    },
    {
        id: 209,
        name: 'Hector',
        assignment: 'W3D5 - Project - Todo-List',
        difficult: 2,
        fun: 4
    },
    {
        id: 210,
        name: 'Hector',
        assignment: 'W4D2-1',
        difficult: 1,
        fun: 1
    },
    {
        id: 211,
        name: 'Hector',
        assignment: 'W4D2-2',
        difficult: 2,
        fun: 1
    },
    {
        id: 212,
        name: 'Hector',
        assignment: 'W4D2-3',
        difficult: 3,
        fun: 3
    },
    {
        id: 213,
        name: 'Hector',
        assignment: 'W4D2-4',
        difficult: 1,
        fun: 3
    },
    {
        id: 214,
        name: 'Hector',
        assignment: 'W4D3-1',
        difficult: 3,
        fun: 3
    },
    {
        id: 215,
        name: 'Hector',
        assignment: 'W4D3-2',
        difficult: 1,
        fun: 4
    },
    {
        id: 216,
        name: 'Hector',
        assignment: 'W4D3-3',
        difficult: 3,
        fun: 1
    },
    {
        id: 217,
        name: 'Hector',
        assignment: 'W4D3-4',
        difficult: 1,
        fun: 3
    },
    {
        id: 218,
        name: 'Hector',
        assignment: 'W4D3-5',
        difficult: 1,
        fun: 2
    },
    {
        id: 219,
        name: 'Hector',
        assignment: 'W4D3 - Project - Next-Level CSS',
        difficult: 3,
        fun: 1
    },
    {
        id: 220,
        name: 'Hector',
        assignment: 'W5D4-1',
        difficult: 3,
        fun: 4
    },
    {
        id: 221,
        name: 'Hector',
        assignment: 'W5D5 - Project - Lil_Playlist',
        difficult: 3,
        fun: 1
    },
    {
        id: 222,
        name: 'Hector',
        assignment: 'W6D1-1',
        difficult: 1,
        fun: 1
    },
    {
        id: 223,
        name: 'Hector',
        assignment: 'W6D2-1',
        difficult: 4,
        fun: 2
    },
    {
        id: 224,
        name: 'Hector',
        assignment: 'W6D2 - Project - Eindopdracht',
        difficult: 2,
        fun: 4
    },
    {
        id: 225,
        name: 'Martina',
        assignment: 'SCRUM',
        difficult: 1,
        fun: 1
    },
    {
        id: 226,
        name: 'Martina',
        assignment: 'W1D1-1',
        difficult: 4,
        fun: 1
    },
    {
        id: 227,
        name: 'Martina',
        assignment: 'W1D2-1',
        difficult: 3,
        fun: 3
    },
    {
        id: 228,
        name: 'Martina',
        assignment: 'W1D2-2',
        difficult: 2,
        fun: 1
    },
    {
        id: 229,
        name: 'Martina',
        assignment: 'W1D2-3',
        difficult: 2,
        fun: 1
    },
    {
        id: 230,
        name: 'Martina',
        assignment: 'W1D2-4',
        difficult: 4,
        fun: 2
    },
    {
        id: 231,
        name: 'Martina',
        assignment: 'W1D2-5',
        difficult: 3,
        fun: 4
    },
    {
        id: 232,
        name: 'Martina',
        assignment: 'W1D3-1',
        difficult: 3,
        fun: 4
    },
    {
        id: 233,
        name: 'Martina',
        assignment: 'W1D3-2',
        difficult: 2,
        fun: 1
    },
    {
        id: 234,
        name: 'Martina',
        assignment: 'W1D3-4',
        difficult: 3,
        fun: 2
    },
    {
        id: 235,
        name: 'Martina',
        assignment: 'W1D3-5',
        difficult: 1,
        fun: 1
    },
    {
        id: 236,
        name: 'Martina',
        assignment: 'W1D3 - Project - Guess-the-number',
        difficult: 2,
        fun: 2
    },
    {
        id: 237,
        name: 'Martina',
        assignment: 'W1D4-1',
        difficult: 4,
        fun: 2
    },
    {
        id: 238,
        name: 'Martina',
        assignment: 'W1D4 - Project - Kleurentoggle',
        difficult: 1,
        fun: 3
    },
    {
        id: 239,
        name: 'Martina',
        assignment: 'W1D5 - Project - Galgje',
        difficult: 1,
        fun: 4
    },
    {
        id: 240,
        name: 'Martina',
        assignment: 'W2D1-1',
        difficult: 1,
        fun: 4
    },
    {
        id: 241,
        name: 'Martina',
        assignment: 'W2D1-2',
        difficult: 4,
        fun: 2
    },
    {
        id: 242,
        name: 'Martina',
        assignment: 'W2D2-1',
        difficult: 4,
        fun: 1
    },
    {
        id: 243,
        name: 'Martina',
        assignment: 'W2D2-2',
        difficult: 3,
        fun: 3
    },
    {
        id: 244,
        name: 'Martina',
        assignment: 'W2D2-3',
        difficult: 3,
        fun: 1
    },
    {
        id: 245,
        name: 'Martina',
        assignment: 'W2D3-1',
        difficult: 4,
        fun: 2
    },
    {
        id: 246,
        name: 'Martina',
        assignment: 'W2D3-2',
        difficult: 3,
        fun: 4
    },
    {
        id: 247,
        name: 'Martina',
        assignment: 'W2D3-3',
        difficult: 3,
        fun: 3
    },
    {
        id: 248,
        name: 'Martina',
        assignment: 'W2D4-1',
        difficult: 1,
        fun: 4
    },
    {
        id: 249,
        name: 'Martina',
        assignment: 'W2D4-2',
        difficult: 3,
        fun: 4
    },
    {
        id: 250,
        name: 'Martina',
        assignment: 'W2D4-3',
        difficult: 3,
        fun: 4
    },
    {
        id: 251,
        name: 'Martina',
        assignment: 'W2D5 - Project - Filmzoeker',
        difficult: 2,
        fun: 4
    },
    {
        id: 252,
        name: 'Martina',
        assignment: 'W3D1-1',
        difficult: 1,
        fun: 1
    },
    {
        id: 253,
        name: 'Martina',
        assignment: 'W3D1-2',
        difficult: 3,
        fun: 3
    },
    {
        id: 254,
        name: 'Martina',
        assignment: 'W3D1-3',
        difficult: 3,
        fun: 1
    },
    {
        id: 255,
        name: 'Martina',
        assignment: 'W3D1-4',
        difficult: 3,
        fun: 2
    },
    {
        id: 256,
        name: 'Martina',
        assignment: 'W3D2-1',
        difficult: 1,
        fun: 2
    },
    {
        id: 257,
        name: 'Martina',
        assignment: 'W3D2-2',
        difficult: 2,
        fun: 4
    },
    {
        id: 258,
        name: 'Martina',
        assignment: 'W3D2-3',
        difficult: 3,
        fun: 1
    },
    {
        id: 259,
        name: 'Martina',
        assignment: 'W3D3-1',
        difficult: 1,
        fun: 4
    },
    {
        id: 260,
        name: 'Martina',
        assignment: 'W3D3-2',
        difficult: 4,
        fun: 1
    },
    {
        id: 261,
        name: 'Martina',
        assignment: 'W3D3-3',
        difficult: 3,
        fun: 3
    },
    {
        id: 262,
        name: 'Martina',
        assignment: 'W3D3-4',
        difficult: 2,
        fun: 3
    },
    {
        id: 263,
        name: 'Martina',
        assignment: 'W3D4-1',
        difficult: 4,
        fun: 4
    },
    {
        id: 264,
        name: 'Martina',
        assignment: 'W3D4-2',
        difficult: 3,
        fun: 1
    },
    {
        id: 265,
        name: 'Martina',
        assignment: 'W3D5 - Project - Todo-List',
        difficult: 2,
        fun: 3
    },
    {
        id: 266,
        name: 'Martina',
        assignment: 'W4D2-1',
        difficult: 3,
        fun: 4
    },
    {
        id: 267,
        name: 'Martina',
        assignment: 'W4D2-2',
        difficult: 1,
        fun: 2
    },
    {
        id: 268,
        name: 'Martina',
        assignment: 'W4D2-3',
        difficult: 3,
        fun: 4
    },
    {
        id: 269,
        name: 'Martina',
        assignment: 'W4D2-4',
        difficult: 4,
        fun: 1
    },
    {
        id: 270,
        name: 'Martina',
        assignment: 'W4D3-1',
        difficult: 2,
        fun: 4
    },
    {
        id: 271,
        name: 'Martina',
        assignment: 'W4D3-2',
        difficult: 1,
        fun: 3
    },
    {
        id: 272,
        name: 'Martina',
        assignment: 'W4D3-3',
        difficult: 2,
        fun: 4
    },
    {
        id: 273,
        name: 'Martina',
        assignment: 'W4D3-4',
        difficult: 4,
        fun: 1
    },
    {
        id: 274,
        name: 'Martina',
        assignment: 'W4D3-5',
        difficult: 3,
        fun: 2
    },
    {
        id: 275,
        name: 'Martina',
        assignment: 'W4D3 - Project - Next-Level CSS',
        difficult: 3,
        fun: 4
    },
    {
        id: 276,
        name: 'Martina',
        assignment: 'W5D4-1',
        difficult: 1,
        fun: 4
    },
    {
        id: 277,
        name: 'Martina',
        assignment: 'W5D5 - Project - Lil_Playlist',
        difficult: 1,
        fun: 1
    },
    {
        id: 278,
        name: 'Martina',
        assignment: 'W6D1-1',
        difficult: 2,
        fun: 1
    },
    {
        id: 279,
        name: 'Martina',
        assignment: 'W6D2-1',
        difficult: 1,
        fun: 4
    },
    {
        id: 280,
        name: 'Martina',
        assignment: 'W6D2 - Project - Eindopdracht',
        difficult: 1,
        fun: 4
    },
    {
        id: 281,
        name: 'Maurits',
        assignment: 'SCRUM',
        difficult: 3,
        fun: 4
    },
    {
        id: 282,
        name: 'Maurits',
        assignment: 'W1D1-1',
        difficult: 4,
        fun: 3
    },
    {
        id: 283,
        name: 'Maurits',
        assignment: 'W1D2-1',
        difficult: 2,
        fun: 2
    },
    {
        id: 284,
        name: 'Maurits',
        assignment: 'W1D2-2',
        difficult: 1,
        fun: 4
    },
    {
        id: 285,
        name: 'Maurits',
        assignment: 'W1D2-3',
        difficult: 2,
        fun: 2
    },
    {
        id: 286,
        name: 'Maurits',
        assignment: 'W1D2-4',
        difficult: 3,
        fun: 1
    },
    {
        id: 287,
        name: 'Maurits',
        assignment: 'W1D2-5',
        difficult: 2,
        fun: 3
    },
    {
        id: 288,
        name: 'Maurits',
        assignment: 'W1D3-1',
        difficult: 2,
        fun: 4
    },
    {
        id: 289,
        name: 'Maurits',
        assignment: 'W1D3-2',
        difficult: 2,
        fun: 2
    },
    {
        id: 290,
        name: 'Maurits',
        assignment: 'W1D3-4',
        difficult: 2,
        fun: 2
    },
    {
        id: 291,
        name: 'Maurits',
        assignment: 'W1D3-5',
        difficult: 1,
        fun: 3
    },
    {
        id: 292,
        name: 'Maurits',
        assignment: 'W1D3 - Project - Guess-the-number',
        difficult: 1,
        fun: 1
    },
    {
        id: 293,
        name: 'Maurits',
        assignment: 'W1D4-1',
        difficult: 3,
        fun: 4
    },
    {
        id: 294,
        name: 'Maurits',
        assignment: 'W1D4 - Project - Kleurentoggle',
        difficult: 4,
        fun: 1
    },
    {
        id: 295,
        name: 'Maurits',
        assignment: 'W1D5 - Project - Galgje',
        difficult: 3,
        fun: 2
    },
    {
        id: 296,
        name: 'Maurits',
        assignment: 'W2D1-1',
        difficult: 1,
        fun: 1
    },
    {
        id: 297,
        name: 'Maurits',
        assignment: 'W2D1-2',
        difficult: 2,
        fun: 3
    },
    {
        id: 298,
        name: 'Maurits',
        assignment: 'W2D2-1',
        difficult: 1,
        fun: 2
    },
    {
        id: 299,
        name: 'Maurits',
        assignment: 'W2D2-2',
        difficult: 4,
        fun: 1
    },
    {
        id: 300,
        name: 'Maurits',
        assignment: 'W2D2-3',
        difficult: 2,
        fun: 2
    },
    {
        id: 301,
        name: 'Maurits',
        assignment: 'W2D3-1',
        difficult: 2,
        fun: 2
    },
    {
        id: 302,
        name: 'Maurits',
        assignment: 'W2D3-2',
        difficult: 3,
        fun: 3
    },
    {
        id: 303,
        name: 'Maurits',
        assignment: 'W2D3-3',
        difficult: 2,
        fun: 1
    },
    {
        id: 304,
        name: 'Maurits',
        assignment: 'W2D4-1',
        difficult: 1,
        fun: 3
    },
    {
        id: 305,
        name: 'Maurits',
        assignment: 'W2D4-2',
        difficult: 3,
        fun: 2
    },
    {
        id: 306,
        name: 'Maurits',
        assignment: 'W2D4-3',
        difficult: 3,
        fun: 3
    },
    {
        id: 307,
        name: 'Maurits',
        assignment: 'W2D5 - Project - Filmzoeker',
        difficult: 3,
        fun: 1
    },
    {
        id: 308,
        name: 'Maurits',
        assignment: 'W3D1-1',
        difficult: 4,
        fun: 4
    },
    {
        id: 309,
        name: 'Maurits',
        assignment: 'W3D1-2',
        difficult: 1,
        fun: 3
    },
    {
        id: 310,
        name: 'Maurits',
        assignment: 'W3D1-3',
        difficult: 1,
        fun: 4
    },
    {
        id: 311,
        name: 'Maurits',
        assignment: 'W3D1-4',
        difficult: 1,
        fun: 2
    },
    {
        id: 312,
        name: 'Maurits',
        assignment: 'W3D2-1',
        difficult: 1,
        fun: 4
    },
    {
        id: 313,
        name: 'Maurits',
        assignment: 'W3D2-2',
        difficult: 1,
        fun: 1
    },
    {
        id: 314,
        name: 'Maurits',
        assignment: 'W3D2-3',
        difficult: 4,
        fun: 3
    },
    {
        id: 315,
        name: 'Maurits',
        assignment: 'W3D3-1',
        difficult: 1,
        fun: 1
    },
    {
        id: 316,
        name: 'Maurits',
        assignment: 'W3D3-2',
        difficult: 2,
        fun: 1
    },
    {
        id: 317,
        name: 'Maurits',
        assignment: 'W3D3-3',
        difficult: 1,
        fun: 3
    },
    {
        id: 318,
        name: 'Maurits',
        assignment: 'W3D3-4',
        difficult: 4,
        fun: 1
    },
    {
        id: 319,
        name: 'Maurits',
        assignment: 'W3D4-1',
        difficult: 4,
        fun: 4
    },
    {
        id: 320,
        name: 'Maurits',
        assignment: 'W3D4-2',
        difficult: 1,
        fun: 3
    },
    {
        id: 321,
        name: 'Maurits',
        assignment: 'W3D5 - Project - Todo-List',
        difficult: 3,
        fun: 4
    },
    {
        id: 322,
        name: 'Maurits',
        assignment: 'W4D2-1',
        difficult: 3,
        fun: 1
    },
    {
        id: 323,
        name: 'Maurits',
        assignment: 'W4D2-2',
        difficult: 4,
        fun: 4
    },
    {
        id: 324,
        name: 'Maurits',
        assignment: 'W4D2-3',
        difficult: 4,
        fun: 1
    },
    {
        id: 325,
        name: 'Maurits',
        assignment: 'W4D2-4',
        difficult: 2,
        fun: 3
    },
    {
        id: 326,
        name: 'Maurits',
        assignment: 'W4D3-1',
        difficult: 3,
        fun: 1
    },
    {
        id: 327,
        name: 'Maurits',
        assignment: 'W4D3-2',
        difficult: 3,
        fun: 2
    },
    {
        id: 328,
        name: 'Maurits',
        assignment: 'W4D3-3',
        difficult: 3,
        fun: 4
    },
    {
        id: 329,
        name: 'Maurits',
        assignment: 'W4D3-4',
        difficult: 1,
        fun: 3
    },
    {
        id: 330,
        name: 'Maurits',
        assignment: 'W4D3-5',
        difficult: 2,
        fun: 1
    },
    {
        id: 331,
        name: 'Maurits',
        assignment: 'W4D3 - Project - Next-Level CSS',
        difficult: 2,
        fun: 3
    },
    {
        id: 332,
        name: 'Maurits',
        assignment: 'W5D4-1',
        difficult: 1,
        fun: 3
    },
    {
        id: 333,
        name: 'Maurits',
        assignment: 'W5D5 - Project - Lil_Playlist',
        difficult: 4,
        fun: 2
    },
    {
        id: 334,
        name: 'Maurits',
        assignment: 'W6D1-1',
        difficult: 1,
        fun: 3
    },
    {
        id: 335,
        name: 'Maurits',
        assignment: 'W6D2-1',
        difficult: 1,
        fun: 4
    },
    {
        id: 336,
        name: 'Maurits',
        assignment: 'W6D2 - Project - Eindopdracht',
        difficult: 3,
        fun: 3
    },
    {
        id: 337,
        name: 'Rahima',
        assignment: 'SCRUM',
        difficult: 2,
        fun: 4
    },
    {
        id: 338,
        name: 'Rahima',
        assignment: 'W1D1-1',
        difficult: 3,
        fun: 4
    },
    {
        id: 339,
        name: 'Rahima',
        assignment: 'W1D2-1',
        difficult: 2,
        fun: 4
    },
    {
        id: 340,
        name: 'Rahima',
        assignment: 'W1D2-2',
        difficult: 1,
        fun: 2
    },
    {
        id: 341,
        name: 'Rahima',
        assignment: 'W1D2-3',
        difficult: 1,
        fun: 3
    },
    {
        id: 342,
        name: 'Rahima',
        assignment: 'W1D2-4',
        difficult: 1,
        fun: 2
    },
    {
        id: 343,
        name: 'Rahima',
        assignment: 'W1D2-5',
        difficult: 1,
        fun: 3
    },
    {
        id: 344,
        name: 'Rahima',
        assignment: 'W1D3-1',
        difficult: 1,
        fun: 1
    },
    {
        id: 345,
        name: 'Rahima',
        assignment: 'W1D3-2',
        difficult: 2,
        fun: 4
    },
    {
        id: 346,
        name: 'Rahima',
        assignment: 'W1D3-4',
        difficult: 1,
        fun: 2
    },
    {
        id: 347,
        name: 'Rahima',
        assignment: 'W1D3-5',
        difficult: 2,
        fun: 2
    },
    {
        id: 348,
        name: 'Rahima',
        assignment: 'W1D3 - Project - Guess-the-number',
        difficult: 3,
        fun: 1
    },
    {
        id: 349,
        name: 'Rahima',
        assignment: 'W1D4-1',
        difficult: 4,
        fun: 3
    },
    {
        id: 350,
        name: 'Rahima',
        assignment: 'W1D4 - Project - Kleurentoggle',
        difficult: 2,
        fun: 4
    },
    {
        id: 351,
        name: 'Rahima',
        assignment: 'W1D5 - Project - Galgje',
        difficult: 3,
        fun: 3
    },
    {
        id: 352,
        name: 'Rahima',
        assignment: 'W2D1-1',
        difficult: 2,
        fun: 2
    },
    {
        id: 353,
        name: 'Rahima',
        assignment: 'W2D1-2',
        difficult: 3,
        fun: 1
    },
    {
        id: 354,
        name: 'Rahima',
        assignment: 'W2D2-1',
        difficult: 1,
        fun: 1
    },
    {
        id: 355,
        name: 'Rahima',
        assignment: 'W2D2-2',
        difficult: 1,
        fun: 1
    },
    {
        id: 356,
        name: 'Rahima',
        assignment: 'W2D2-3',
        difficult: 4,
        fun: 2
    },
    {
        id: 357,
        name: 'Rahima',
        assignment: 'W2D3-1',
        difficult: 1,
        fun: 1
    },
    {
        id: 358,
        name: 'Rahima',
        assignment: 'W2D3-2',
        difficult: 1,
        fun: 4
    },
    {
        id: 359,
        name: 'Rahima',
        assignment: 'W2D3-3',
        difficult: 4,
        fun: 2
    },
    {
        id: 360,
        name: 'Rahima',
        assignment: 'W2D4-1',
        difficult: 4,
        fun: 4
    },
    {
        id: 361,
        name: 'Rahima',
        assignment: 'W2D4-2',
        difficult: 4,
        fun: 4
    },
    {
        id: 362,
        name: 'Rahima',
        assignment: 'W2D4-3',
        difficult: 2,
        fun: 3
    },
    {
        id: 363,
        name: 'Rahima',
        assignment: 'W2D5 - Project - Filmzoeker',
        difficult: 3,
        fun: 1
    },
    {
        id: 364,
        name: 'Rahima',
        assignment: 'W3D1-1',
        difficult: 1,
        fun: 1
    },
    {
        id: 365,
        name: 'Rahima',
        assignment: 'W3D1-2',
        difficult: 1,
        fun: 2
    },
    {
        id: 366,
        name: 'Rahima',
        assignment: 'W3D1-3',
        difficult: 2,
        fun: 3
    },
    {
        id: 367,
        name: 'Rahima',
        assignment: 'W3D1-4',
        difficult: 2,
        fun: 4
    },
    {
        id: 368,
        name: 'Rahima',
        assignment: 'W3D2-1',
        difficult: 3,
        fun: 2
    },
    {
        id: 369,
        name: 'Rahima',
        assignment: 'W3D2-2',
        difficult: 1,
        fun: 4
    },
    {
        id: 370,
        name: 'Rahima',
        assignment: 'W3D2-3',
        difficult: 2,
        fun: 1
    },
    {
        id: 371,
        name: 'Rahima',
        assignment: 'W3D3-1',
        difficult: 3,
        fun: 1
    },
    {
        id: 372,
        name: 'Rahima',
        assignment: 'W3D3-2',
        difficult: 4,
        fun: 4
    },
    {
        id: 373,
        name: 'Rahima',
        assignment: 'W3D3-3',
        difficult: 1,
        fun: 4
    },
    {
        id: 374,
        name: 'Rahima',
        assignment: 'W3D3-4',
        difficult: 2,
        fun: 2
    },
    {
        id: 375,
        name: 'Rahima',
        assignment: 'W3D4-1',
        difficult: 1,
        fun: 2
    },
    {
        id: 376,
        name: 'Rahima',
        assignment: 'W3D4-2',
        difficult: 3,
        fun: 3
    },
    {
        id: 377,
        name: 'Rahima',
        assignment: 'W3D5 - Project - Todo-List',
        difficult: 2,
        fun: 4
    },
    {
        id: 378,
        name: 'Rahima',
        assignment: 'W4D2-1',
        difficult: 2,
        fun: 4
    },
    {
        id: 379,
        name: 'Rahima',
        assignment: 'W4D2-2',
        difficult: 4,
        fun: 3
    },
    {
        id: 380,
        name: 'Rahima',
        assignment: 'W4D2-3',
        difficult: 3,
        fun: 3
    },
    {
        id: 381,
        name: 'Rahima',
        assignment: 'W4D2-4',
        difficult: 4,
        fun: 1
    },
    {
        id: 382,
        name: 'Rahima',
        assignment: 'W4D3-1',
        difficult: 2,
        fun: 1
    },
    {
        id: 383,
        name: 'Rahima',
        assignment: 'W4D3-2',
        difficult: 1,
        fun: 1
    },
    {
        id: 384,
        name: 'Rahima',
        assignment: 'W4D3-3',
        difficult: 2,
        fun: 1
    },
    {
        id: 385,
        name: 'Rahima',
        assignment: 'W4D3-4',
        difficult: 2,
        fun: 2
    },
    {
        id: 386,
        name: 'Rahima',
        assignment: 'W4D3-5',
        difficult: 3,
        fun: 2
    },
    {
        id: 387,
        name: 'Rahima',
        assignment: 'W4D3 - Project - Next-Level CSS',
        difficult: 1,
        fun: 2
    },
    {
        id: 388,
        name: 'Rahima',
        assignment: 'W5D4-1',
        difficult: 3,
        fun: 3
    },
    {
        id: 389,
        name: 'Rahima',
        assignment: 'W5D5 - Project - Lil_Playlist',
        difficult: 2,
        fun: 3
    },
    {
        id: 390,
        name: 'Rahima',
        assignment: 'W6D1-1',
        difficult: 4,
        fun: 4
    },
    {
        id: 391,
        name: 'Rahima',
        assignment: 'W6D2-1',
        difficult: 1,
        fun: 4
    },
    {
        id: 392,
        name: 'Rahima',
        assignment: 'W6D2 - Project - Eindopdracht',
        difficult: 4,
        fun: 1
    },
    {
        id: 393,
        name: 'Sandra',
        assignment: 'SCRUM',
        difficult: 4,
        fun: 1
    },
    {
        id: 394,
        name: 'Sandra',
        assignment: 'W1D1-1',
        difficult: 2,
        fun: 4
    },
    {
        id: 395,
        name: 'Sandra',
        assignment: 'W1D2-1',
        difficult: 3,
        fun: 4
    },
    {
        id: 396,
        name: 'Sandra',
        assignment: 'W1D2-2',
        difficult: 3,
        fun: 2
    },
    {
        id: 397,
        name: 'Sandra',
        assignment: 'W1D2-3',
        difficult: 3,
        fun: 4
    },
    {
        id: 398,
        name: 'Sandra',
        assignment: 'W1D2-4',
        difficult: 3,
        fun: 1
    },
    {
        id: 399,
        name: 'Sandra',
        assignment: 'W1D2-5',
        difficult: 4,
        fun: 3
    },
    {
        id: 400,
        name: 'Sandra',
        assignment: 'W1D3-1',
        difficult: 1,
        fun: 1
    },
    {
        id: 401,
        name: 'Sandra',
        assignment: 'W1D3-2',
        difficult: 1,
        fun: 1
    },
    {
        id: 402,
        name: 'Sandra',
        assignment: 'W1D3-4',
        difficult: 3,
        fun: 3
    },
    {
        id: 403,
        name: 'Sandra',
        assignment: 'W1D3-5',
        difficult: 4,
        fun: 3
    },
    {
        id: 404,
        name: 'Sandra',
        assignment: 'W1D3 - Project - Guess-the-number',
        difficult: 2,
        fun: 4
    },
    {
        id: 405,
        name: 'Sandra',
        assignment: 'W1D4-1',
        difficult: 3,
        fun: 2
    },
    {
        id: 406,
        name: 'Sandra',
        assignment: 'W1D4 - Project - Kleurentoggle',
        difficult: 1,
        fun: 3
    },
    {
        id: 407,
        name: 'Sandra',
        assignment: 'W1D5 - Project - Galgje',
        difficult: 3,
        fun: 3
    },
    {
        id: 408,
        name: 'Sandra',
        assignment: 'W2D1-1',
        difficult: 4,
        fun: 1
    },
    {
        id: 409,
        name: 'Sandra',
        assignment: 'W2D1-2',
        difficult: 4,
        fun: 3
    },
    {
        id: 410,
        name: 'Sandra',
        assignment: 'W2D2-1',
        difficult: 3,
        fun: 4
    },
    {
        id: 411,
        name: 'Sandra',
        assignment: 'W2D2-2',
        difficult: 2,
        fun: 3
    },
    {
        id: 412,
        name: 'Sandra',
        assignment: 'W2D2-3',
        difficult: 4,
        fun: 3
    },
    {
        id: 413,
        name: 'Sandra',
        assignment: 'W2D3-1',
        difficult: 1,
        fun: 2
    },
    {
        id: 414,
        name: 'Sandra',
        assignment: 'W2D3-2',
        difficult: 3,
        fun: 2
    },
    {
        id: 415,
        name: 'Sandra',
        assignment: 'W2D3-3',
        difficult: 2,
        fun: 2
    },
    {
        id: 416,
        name: 'Sandra',
        assignment: 'W2D4-1',
        difficult: 1,
        fun: 3
    },
    {
        id: 417,
        name: 'Sandra',
        assignment: 'W2D4-2',
        difficult: 2,
        fun: 4
    },
    {
        id: 418,
        name: 'Sandra',
        assignment: 'W2D4-3',
        difficult: 2,
        fun: 2
    },
    {
        id: 419,
        name: 'Sandra',
        assignment: 'W2D5 - Project - Filmzoeker',
        difficult: 2,
        fun: 4
    },
    {
        id: 420,
        name: 'Sandra',
        assignment: 'W3D1-1',
        difficult: 3,
        fun: 3
    },
    {
        id: 421,
        name: 'Sandra',
        assignment: 'W3D1-2',
        difficult: 3,
        fun: 4
    },
    {
        id: 422,
        name: 'Sandra',
        assignment: 'W3D1-3',
        difficult: 2,
        fun: 4
    },
    {
        id: 423,
        name: 'Sandra',
        assignment: 'W3D1-4',
        difficult: 2,
        fun: 2
    },
    {
        id: 424,
        name: 'Sandra',
        assignment: 'W3D2-1',
        difficult: 2,
        fun: 4
    },
    {
        id: 425,
        name: 'Sandra',
        assignment: 'W3D2-2',
        difficult: 2,
        fun: 3
    },
    {
        id: 426,
        name: 'Sandra',
        assignment: 'W3D2-3',
        difficult: 1,
        fun: 2
    },
    {
        id: 427,
        name: 'Sandra',
        assignment: 'W3D3-1',
        difficult: 1,
        fun: 2
    },
    {
        id: 428,
        name: 'Sandra',
        assignment: 'W3D3-2',
        difficult: 2,
        fun: 2
    },
    {
        id: 429,
        name: 'Sandra',
        assignment: 'W3D3-3',
        difficult: 4,
        fun: 4
    },
    {
        id: 430,
        name: 'Sandra',
        assignment: 'W3D3-4',
        difficult: 3,
        fun: 2
    },
    {
        id: 431,
        name: 'Sandra',
        assignment: 'W3D4-1',
        difficult: 2,
        fun: 3
    },
    {
        id: 432,
        name: 'Sandra',
        assignment: 'W3D4-2',
        difficult: 1,
        fun: 1
    },
    {
        id: 433,
        name: 'Sandra',
        assignment: 'W3D5 - Project - Todo-List',
        difficult: 1,
        fun: 2
    },
    {
        id: 434,
        name: 'Sandra',
        assignment: 'W4D2-1',
        difficult: 3,
        fun: 3
    },
    {
        id: 435,
        name: 'Sandra',
        assignment: 'W4D2-2',
        difficult: 1,
        fun: 1
    },
    {
        id: 436,
        name: 'Sandra',
        assignment: 'W4D2-3',
        difficult: 3,
        fun: 4
    },
    {
        id: 437,
        name: 'Sandra',
        assignment: 'W4D2-4',
        difficult: 1,
        fun: 4
    },
    {
        id: 438,
        name: 'Sandra',
        assignment: 'W4D3-1',
        difficult: 3,
        fun: 1
    },
    {
        id: 439,
        name: 'Sandra',
        assignment: 'W4D3-2',
        difficult: 1,
        fun: 3
    },
    {
        id: 440,
        name: 'Sandra',
        assignment: 'W4D3-3',
        difficult: 2,
        fun: 4
    },
    {
        id: 441,
        name: 'Sandra',
        assignment: 'W4D3-4',
        difficult: 1,
        fun: 4
    },
    {
        id: 442,
        name: 'Sandra',
        assignment: 'W4D3-5',
        difficult: 1,
        fun: 3
    },
    {
        id: 443,
        name: 'Sandra',
        assignment: 'W4D3 - Project - Next-Level CSS',
        difficult: 3,
        fun: 4
    },
    {
        id: 444,
        name: 'Sandra',
        assignment: 'W5D4-1',
        difficult: 1,
        fun: 1
    },
    {
        id: 445,
        name: 'Sandra',
        assignment: 'W5D5 - Project - Lil_Playlist',
        difficult: 2,
        fun: 2
    },
    {
        id: 446,
        name: 'Sandra',
        assignment: 'W6D1-1',
        difficult: 1,
        fun: 4
    },
    {
        id: 447,
        name: 'Sandra',
        assignment: 'W6D2-1',
        difficult: 2,
        fun: 3
    },
    {
        id: 448,
        name: 'Sandra',
        assignment: 'W6D2 - Project - Eindopdracht',
        difficult: 4,
        fun: 1
    },
    {
        id: 449,
        name: 'Wietske',
        assignment: 'SCRUM',
        difficult: 1,
        fun: 1
    },
    {
        id: 450,
        name: 'Wietske',
        assignment: 'W1D1-1',
        difficult: 4,
        fun: 3
    },
    {
        id: 451,
        name: 'Wietske',
        assignment: 'W1D2-1',
        difficult: 1,
        fun: 4
    },
    {
        id: 452,
        name: 'Wietske',
        assignment: 'W1D2-2',
        difficult: 1,
        fun: 2
    },
    {
        id: 453,
        name: 'Wietske',
        assignment: 'W1D2-3',
        difficult: 2,
        fun: 3
    },
    {
        id: 454,
        name: 'Wietske',
        assignment: 'W1D2-4',
        difficult: 2,
        fun: 1
    },
    {
        id: 455,
        name: 'Wietske',
        assignment: 'W1D2-5',
        difficult: 3,
        fun: 4
    },
    {
        id: 456,
        name: 'Wietske',
        assignment: 'W1D3-1',
        difficult: 1,
        fun: 2
    },
    {
        id: 457,
        name: 'Wietske',
        assignment: 'W1D3-2',
        difficult: 1,
        fun: 4
    },
    {
        id: 458,
        name: 'Wietske',
        assignment: 'W1D3-4',
        difficult: 2,
        fun: 1
    },
    {
        id: 459,
        name: 'Wietske',
        assignment: 'W1D3-5',
        difficult: 3,
        fun: 4
    },
    {
        id: 460,
        name: 'Wietske',
        assignment: 'W1D3 - Project - Guess-the-number',
        difficult: 2,
        fun: 4
    },
    {
        id: 461,
        name: 'Wietske',
        assignment: 'W1D4-1',
        difficult: 2,
        fun: 4
    },
    {
        id: 462,
        name: 'Wietske',
        assignment: 'W1D4 - Project - Kleurentoggle',
        difficult: 2,
        fun: 3
    },
    {
        id: 463,
        name: 'Wietske',
        assignment: 'W1D5 - Project - Galgje',
        difficult: 3,
        fun: 3
    },
    {
        id: 464,
        name: 'Wietske',
        assignment: 'W2D1-1',
        difficult: 3,
        fun: 1
    },
    {
        id: 465,
        name: 'Wietske',
        assignment: 'W2D1-2',
        difficult: 4,
        fun: 1
    },
    {
        id: 466,
        name: 'Wietske',
        assignment: 'W2D2-1',
        difficult: 2,
        fun: 2
    },
    {
        id: 467,
        name: 'Wietske',
        assignment: 'W2D2-2',
        difficult: 2,
        fun: 4
    },
    {
        id: 468,
        name: 'Wietske',
        assignment: 'W2D2-3',
        difficult: 3,
        fun: 4
    },
    {
        id: 469,
        name: 'Wietske',
        assignment: 'W2D3-1',
        difficult: 2,
        fun: 1
    },
    {
        id: 470,
        name: 'Wietske',
        assignment: 'W2D3-2',
        difficult: 1,
        fun: 1
    },
    {
        id: 471,
        name: 'Wietske',
        assignment: 'W2D3-3',
        difficult: 2,
        fun: 3
    },
    {
        id: 472,
        name: 'Wietske',
        assignment: 'W2D4-1',
        difficult: 1,
        fun: 1
    },
    {
        id: 473,
        name: 'Wietske',
        assignment: 'W2D4-2',
        difficult: 2,
        fun: 4
    },
    {
        id: 474,
        name: 'Wietske',
        assignment: 'W2D4-3',
        difficult: 4,
        fun: 3
    },
    {
        id: 475,
        name: 'Wietske',
        assignment: 'W2D5 - Project - Filmzoeker',
        difficult: 2,
        fun: 2
    },
    {
        id: 476,
        name: 'Wietske',
        assignment: 'W3D1-1',
        difficult: 1,
        fun: 3
    },
    {
        id: 477,
        name: 'Wietske',
        assignment: 'W3D1-2',
        difficult: 4,
        fun: 4
    },
    {
        id: 478,
        name: 'Wietske',
        assignment: 'W3D1-3',
        difficult: 4,
        fun: 2
    },
    {
        id: 479,
        name: 'Wietske',
        assignment: 'W3D1-4',
        difficult: 1,
        fun: 4
    },
    {
        id: 480,
        name: 'Wietske',
        assignment: 'W3D2-1',
        difficult: 3,
        fun: 2
    },
    {
        id: 481,
        name: 'Wietske',
        assignment: 'W3D2-2',
        difficult: 1,
        fun: 3
    },
    {
        id: 482,
        name: 'Wietske',
        assignment: 'W3D2-3',
        difficult: 2,
        fun: 4
    },
    {
        id: 483,
        name: 'Wietske',
        assignment: 'W3D3-1',
        difficult: 1,
        fun: 4
    },
    {
        id: 484,
        name: 'Wietske',
        assignment: 'W3D3-2',
        difficult: 3,
        fun: 1
    },
    {
        id: 485,
        name: 'Wietske',
        assignment: 'W3D3-3',
        difficult: 1,
        fun: 3
    },
    {
        id: 486,
        name: 'Wietske',
        assignment: 'W3D3-4',
        difficult: 3,
        fun: 4
    },
    {
        id: 487,
        name: 'Wietske',
        assignment: 'W3D4-1',
        difficult: 3,
        fun: 4
    },
    {
        id: 488,
        name: 'Wietske',
        assignment: 'W3D4-2',
        difficult: 4,
        fun: 2
    },
    {
        id: 489,
        name: 'Wietske',
        assignment: 'W3D5 - Project - Todo-List',
        difficult: 2,
        fun: 4
    },
    {
        id: 490,
        name: 'Wietske',
        assignment: 'W4D2-1',
        difficult: 3,
        fun: 3
    },
    {
        id: 491,
        name: 'Wietske',
        assignment: 'W4D2-2',
        difficult: 2,
        fun: 4
    },
    {
        id: 492,
        name: 'Wietske',
        assignment: 'W4D2-3',
        difficult: 1,
        fun: 2
    },
    {
        id: 493,
        name: 'Wietske',
        assignment: 'W4D2-4',
        difficult: 4,
        fun: 3
    },
    {
        id: 494,
        name: 'Wietske',
        assignment: 'W4D3-1',
        difficult: 2,
        fun: 1
    },
    {
        id: 495,
        name: 'Wietske',
        assignment: 'W4D3-2',
        difficult: 1,
        fun: 2
    },
    {
        id: 496,
        name: 'Wietske',
        assignment: 'W4D3-3',
        difficult: 1,
        fun: 4
    },
    {
        id: 497,
        name: 'Wietske',
        assignment: 'W4D3-4',
        difficult: 3,
        fun: 4
    },
    {
        id: 498,
        name: 'Wietske',
        assignment: 'W4D3-5',
        difficult: 4,
        fun: 3
    },
    {
        id: 499,
        name: 'Wietske',
        assignment: 'W4D3 - Project - Next-Level CSS',
        difficult: 4,
        fun: 2
    },
    {
        id: 500,
        name: 'Wietske',
        assignment: 'W5D4-1',
        difficult: 3,
        fun: 1
    },
    {
        id: 501,
        name: 'Wietske',
        assignment: 'W5D5 - Project - Lil_Playlist',
        difficult: 4,
        fun: 2
    },
    {
        id: 502,
        name: 'Wietske',
        assignment: 'W6D1-1',
        difficult: 1,
        fun: 1
    },
    {
        id: 503,
        name: 'Wietske',
        assignment: 'W6D2-1',
        difficult: 2,
        fun: 1
    },
    {
        id: 504,
        name: 'Wietske',
        assignment: 'W6D2 - Project - Eindopdracht',
        difficult: 1,
        fun: 2
    },
    {
        id: 505,
        name: 'Storm',
        assignment: 'SCRUM',
        difficult: 1,
        fun: 1
    },
    {
        id: 506,
        name: 'Storm',
        assignment: 'W1D1-1',
        difficult: 2,
        fun: 2
    },
    {
        id: 507,
        name: 'Storm',
        assignment: 'W1D2-1',
        difficult: 2,
        fun: 3
    },
    {
        id: 508,
        name: 'Storm',
        assignment: 'W1D2-2',
        difficult: 1,
        fun: 3
    },
    {
        id: 509,
        name: 'Storm',
        assignment: 'W1D2-3',
        difficult: 1,
        fun: 2
    },
    {
        id: 510,
        name: 'Storm',
        assignment: 'W1D2-4',
        difficult: 4,
        fun: 3
    },
    {
        id: 511,
        name: 'Storm',
        assignment: 'W1D2-5',
        difficult: 3,
        fun: 3
    },
    {
        id: 512,
        name: 'Storm',
        assignment: 'W1D3-1',
        difficult: 2,
        fun: 3
    },
    {
        id: 513,
        name: 'Storm',
        assignment: 'W1D3-2',
        difficult: 1,
        fun: 1
    },
    {
        id: 514,
        name: 'Storm',
        assignment: 'W1D3-4',
        difficult: 1,
        fun: 1
    },
    {
        id: 515,
        name: 'Storm',
        assignment: 'W1D3-5',
        difficult: 2,
        fun: 2
    },
    {
        id: 516,
        name: 'Storm',
        assignment: 'W1D3 - Project - Guess-the-number',
        difficult: 3,
        fun: 4
    },
    {
        id: 517,
        name: 'Storm',
        assignment: 'W1D4-1',
        difficult: 4,
        fun: 2
    },
    {
        id: 518,
        name: 'Storm',
        assignment: 'W1D4 - Project - Kleurentoggle',
        difficult: 3,
        fun: 2
    },
    {
        id: 519,
        name: 'Storm',
        assignment: 'W1D5 - Project - Galgje',
        difficult: 4,
        fun: 4
    },
    {
        id: 520,
        name: 'Storm',
        assignment: 'W2D1-1',
        difficult: 2,
        fun: 4
    },
    {
        id: 521,
        name: 'Storm',
        assignment: 'W2D1-2',
        difficult: 3,
        fun: 2
    },
    {
        id: 522,
        name: 'Storm',
        assignment: 'W2D2-1',
        difficult: 4,
        fun: 4
    },
    {
        id: 523,
        name: 'Storm',
        assignment: 'W2D2-2',
        difficult: 2,
        fun: 1
    },
    {
        id: 524,
        name: 'Storm',
        assignment: 'W2D2-3',
        difficult: 1,
        fun: 1
    },
    {
        id: 525,
        name: 'Storm',
        assignment: 'W2D3-1',
        difficult: 2,
        fun: 3
    },
    {
        id: 526,
        name: 'Storm',
        assignment: 'W2D3-2',
        difficult: 3,
        fun: 4
    },
    {
        id: 527,
        name: 'Storm',
        assignment: 'W2D3-3',
        difficult: 3,
        fun: 2
    },
    {
        id: 528,
        name: 'Storm',
        assignment: 'W2D4-1',
        difficult: 3,
        fun: 4
    },
    {
        id: 529,
        name: 'Storm',
        assignment: 'W2D4-2',
        difficult: 4,
        fun: 3
    },
    {
        id: 530,
        name: 'Storm',
        assignment: 'W2D4-3',
        difficult: 2,
        fun: 1
    },
    {
        id: 531,
        name: 'Storm',
        assignment: 'W2D5 - Project - Filmzoeker',
        difficult: 4,
        fun: 1
    },
    {
        id: 532,
        name: 'Storm',
        assignment: 'W3D1-1',
        difficult: 2,
        fun: 1
    },
    {
        id: 533,
        name: 'Storm',
        assignment: 'W3D1-2',
        difficult: 2,
        fun: 2
    },
    {
        id: 534,
        name: 'Storm',
        assignment: 'W3D1-3',
        difficult: 1,
        fun: 2
    },
    {
        id: 535,
        name: 'Storm',
        assignment: 'W3D1-4',
        difficult: 2,
        fun: 3
    },
    {
        id: 536,
        name: 'Storm',
        assignment: 'W3D2-1',
        difficult: 1,
        fun: 4
    },
    {
        id: 537,
        name: 'Storm',
        assignment: 'W3D2-2',
        difficult: 3,
        fun: 3
    },
    {
        id: 538,
        name: 'Storm',
        assignment: 'W3D2-3',
        difficult: 3,
        fun: 4
    },
    {
        id: 539,
        name: 'Storm',
        assignment: 'W3D3-1',
        difficult: 3,
        fun: 4
    },
    {
        id: 540,
        name: 'Storm',
        assignment: 'W3D3-2',
        difficult: 1,
        fun: 2
    },
    {
        id: 541,
        name: 'Storm',
        assignment: 'W3D3-3',
        difficult: 3,
        fun: 1
    },
    {
        id: 542,
        name: 'Storm',
        assignment: 'W3D3-4',
        difficult: 3,
        fun: 1
    },
    {
        id: 543,
        name: 'Storm',
        assignment: 'W3D4-1',
        difficult: 2,
        fun: 4
    },
    {
        id: 544,
        name: 'Storm',
        assignment: 'W3D4-2',
        difficult: 3,
        fun: 4
    },
    {
        id: 545,
        name: 'Storm',
        assignment: 'W3D5 - Project - Todo-List',
        difficult: 3,
        fun: 2
    },
    {
        id: 546,
        name: 'Storm',
        assignment: 'W4D2-1',
        difficult: 2,
        fun: 1
    },
    {
        id: 547,
        name: 'Storm',
        assignment: 'W4D2-2',
        difficult: 3,
        fun: 3
    },
    {
        id: 548,
        name: 'Storm',
        assignment: 'W4D2-3',
        difficult: 2,
        fun: 2
    },
    {
        id: 549,
        name: 'Storm',
        assignment: 'W4D2-4',
        difficult: 3,
        fun: 4
    },
    {
        id: 550,
        name: 'Storm',
        assignment: 'W4D3-1',
        difficult: 3,
        fun: 4
    },
    {
        id: 551,
        name: 'Storm',
        assignment: 'W4D3-2',
        difficult: 2,
        fun: 3
    },
    {
        id: 552,
        name: 'Storm',
        assignment: 'W4D3-3',
        difficult: 1,
        fun: 1
    },
    {
        id: 553,
        name: 'Storm',
        assignment: 'W4D3-4',
        difficult: 3,
        fun: 1
    },
    {
        id: 554,
        name: 'Storm',
        assignment: 'W4D3-5',
        difficult: 2,
        fun: 3
    },
    {
        id: 555,
        name: 'Storm',
        assignment: 'W4D3 - Project - Next-Level CSS',
        difficult: 4,
        fun: 1
    },
    {
        id: 556,
        name: 'Storm',
        assignment: 'W5D4-1',
        difficult: 2,
        fun: 2
    },
    {
        id: 557,
        name: 'Storm',
        assignment: 'W5D5 - Project - Lil_Playlist',
        difficult: 1,
        fun: 2
    },
    {
        id: 558,
        name: 'Storm',
        assignment: 'W6D1-1',
        difficult: 4,
        fun: 4
    },
    {
        id: 559,
        name: 'Storm',
        assignment: 'W6D2-1',
        difficult: 1,
        fun: 1
    },
    {
        id: 560,
        name: 'Storm',
        assignment: 'W6D2 - Project - Eindopdracht',
        difficult: 3,
        fun: 3
    }
]

export default StudentData;